import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import { SNETButton, AlertBox, alertTypes } from "shared/dist/components";
import validator from "shared/dist/utils/validator";
import { serviceProfileValidationConstraints } from "./validationConstraints";
import ValidationError from "shared/dist/utils/validationError";
import { checkIfKnownError } from "shared/dist/utils/error";
import { DEMO } from "../Routes";
import { aiServiceDetailsActions } from "../../../Services/Redux/actionCreators";
import { serviceIdAvailability, progressStatus, sections } from "../constant";
import { setCreateNewAiService } from "../../../Services/Redux/actionCreators/aiServiceDetailsActions";

import ServiceProfileImageUpload from "./ServiceProfileImageUpload";
import BasicServiceDetails from "./BasicServiceDetails";
import { isEmpty, isUndefined } from "lodash";
import { storageProviders } from "../../../Utils/storageTypes";
import classes from "./ServiceProfileImageUpload.module.css";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import FormActions from "../../../Components/PageFormComponents/FormActions";
import FormContentCard from "../../../Components/PageFormComponents/FormContentCard";

const Profile = () => {
    const dispatch = useDispatch();
    const navigateTo = useNavigateTo();
    const { orgUuid } = useParams();
    const serviceDetails = useSelector((state) => state.aiServiceDetails);
    const [alert, setAlert] = useState({});
    const [isDisableContinueButton, setIsDisableContinueButton] = useState(false);

    useEffect(() => {
        const isFormInvalid = () => {
            const invalidFields = validator(serviceDetails, serviceProfileValidationConstraints, {
                format: "flat",
            });
            const isFilecoinTokenExist =
                serviceDetails.storageProvider !== storageProviders.FILECOIN ||
                !isEmpty(serviceDetails.lighthouseToken);
            return !isUndefined(invalidFields) || !isFilecoinTokenExist;
        };

        setIsDisableContinueButton(isFormInvalid());
    }, [serviceDetails]);

    const handleSave = async () => {
        if (
            serviceDetails.newId !== serviceDetails.id &&
            serviceDetails.availability !== serviceIdAvailability.AVAILABLE
        ) {
            throw new ValidationError(
                "Service id is not available. Try with a different service id"
            );
        }
        if (serviceDetails.touched) {
            await dispatch(aiServiceDetailsActions.saveServiceDetails(orgUuid, serviceDetails));
        }

        return;
    };

    const handleContinue = async () => {
        try {
            await handleSave();
            dispatch(
                aiServiceDetailsActions.updateProgressStatus(
                    sections.AI_PROFILE,
                    progressStatus.COMPLETED,
                    serviceDetails.progressStages
                )
            );
            navigateTo.aiServiceCreation({ orgUuid, serviceUuid: serviceDetails.uuid }, DEMO.path);
        } catch (error) {
            if (checkIfKnownError(error)) {
                return setAlert({ type: alertTypes.ERROR, message: error.message });
            }
            return setAlert({ type: alertTypes.ERROR, message: "something went wrong" });
        }
    };

    const handleFinishLater = async () => {
        dispatch(setCreateNewAiService(false));
        try {
            await handleSave();
            navigateTo.services({ orgUuid });
        } catch (error) {
            if (checkIfKnownError(error)) {
                return setAlert({ type: alertTypes.ERROR, message: error.message });
            }
            return setAlert({ type: alertTypes.ERROR, message: "something went wrong" });
        }
    };

    return (
        <Fragment>
            <FormContentCard
                title="AI Service Profile Information"
                description={`
                     Please enter the description and details of the service you wish to add to
                    the AI marketplace, making sure your descriptions are clear as this will be
                    displayed on the AI marketplace.
                `}
            >
                <BasicServiceDetails />
                <ServiceProfileImageUpload />
                {alert.message && (
                    <div className={classes.alertContainer}>
                        <AlertBox
                            type={alert.type}
                            message={alert.message}
                            children={alert.children}
                        />
                    </div>
                )}
            </FormContentCard>

            <FormActions>
                <SNETButton
                    children="finish later"
                    color="primary"
                    variant="outlined"
                    onClick={handleFinishLater}
                />
                <SNETButton
                    children="continue"
                    color="primary"
                    disabled={isDisableContinueButton}
                    variant="contained"
                    onClick={handleContinue}
                />
            </FormActions>
        </Fragment>
    );
};
export default Profile;
